module.exports = __webpack_public_path__ + "static/media/progress.d14fc89f.svg";